<script>
    import { toInteger } from 'lodash'
    import Popper from 'popper.js'
    import { VueMixin, redirect, modalClose } from "../utility"
    import { loading } from "../core/page-loader"
    import PdfSelector from '../eventcalculator/inline-components/PdfSelector.vue'

    export default {
        mixins: [VueMixin],
        props: [
            'calculation'
        ],
        components: {PdfSelector},
        data() {
            return {
                showDropDownMenu: false,
                pdfDownloadLink: null,
                firstTime: true
            }
        },
        mounted() {
            this.initPopperMenu()
        },
        methods: {
            generatePdf() {
                this.$event.$emit('generate-pdf', {
                    id: this.calculation.public_id,
                    type: '\\App\\Calculation'
                })
            },
            openContainerModal() {
                $('#select-container-modal').addClass('active')
                $('#select-container-confirm').one('click', () => {
                    axios.post('/calculation/to/container', {
                        calculation_id: this.calculation.id,
                        container_id: toInteger($('#calculation-container-selector').val())
                    }).then(() => {
                        loading(false)
                    }).catch((error) => {
                        loading(false)
                        console.error('error in MyEvents', error)
                    })
                })
                $(document).on('modals-was-closed', () => {
                    $('#select-container-confirm').off()
                })
            },
            openDeleteCalculationModal(deleteLink) {
                let $deleteCalculationModal = $('#delete-calculation-modal')
                $deleteCalculationModal.addClass('active')

                $('#delete-calculation-cancel').one('click', function() {
                    modalClose()
                    $("#delete-calculation-confirm, #delete-calculation-cancel" ).off()
                })

                $('#delete-calculation-confirm').one('click', function() {
                    redirect(deleteLink)
                })
            },
            pdfDownload() {
                loading(true)

                redirect(this.pdfDownloadLink.download)

                setTimeout(() => {
                    loading(false)
                }, 6000)
            },
            generateAndDownload(event) {
                loading(true)
                    
                axios.get(event.target.href).then((response) => {
                    this.calculation.pdfs.push(response.data)

                    redirect(response.data)

                    loading(false)
                }).catch((error) => {
                    loading(false)
                    console.error('error in MyEvents', error)
                })
            },
            requestOffer() {
                this.$event.$emit('call-contact-modal', {
                    scope: "request-offer",
                    boundToCalculation: this.calculation.public_id
                })

                // window.contactFormulaModal.scope = "request-offer"
                // window.contactFormulaModal.boundToCalculation = this.calculation.public_id
                // window.contactFormulaModal.callContactModal()
            },
            deletePdf() {
                redirect(event.target.href)
            },
            initPopperMenu() {
                let onPopper = this.$el.querySelector('.menu-popper'),
                    reference = this.$el.querySelector('.menu-toggle i')
                    
                new Popper(reference, onPopper, {
                    placement: 'bottom-end',
                    offset: 30,
                    modifiers: {
                        offset: { 
                            enabled: true,
                            offset: '16,3'
                        }
                    }
                })
            },
            toggleDropdownMenuListener(e) {
                if(e.target.parentElement.className !== 'menu-popper' && !this.firstTime)  {
                    this.showDropDownMenu = false

                    document.removeEventListener('click', this.toggleDropdownMenuListener)

                }
                
                this.firstTime = false
            },
            toggleDropdownMenu() {
                this.firstTime = true

                this.showDropDownMenu = !this.showDropDownMenu

                if(this.showDropDownMenu) {
                    document.addEventListener("click", this.toggleDropdownMenuListener, false)
                }
            }
        },
        template: '#calculation-box-template',
    }
</script>
